__turbopack_context__.v({
  "content": "_3ZRJ0a_content",
  "description": "_3ZRJ0a_description",
  "image": "_3ZRJ0a_image",
  "img": "_3ZRJ0a_img",
  "progressBar": "_3ZRJ0a_progressBar",
  "progressContainer": "_3ZRJ0a_progressContainer",
  "progressFill": "_3ZRJ0a_progressFill",
  "progressText": "_3ZRJ0a_progressText",
  "row": "_3ZRJ0a_row",
  "title": "_3ZRJ0a_title",
  "titleGroup": "_3ZRJ0a_titleGroup",
});
